import { render, staticRenderFns } from "./PagePreview.vue?vue&type=template&id=552b6e40&scoped=true&"
import script from "./PagePreview.vue?vue&type=script&lang=js&"
export * from "./PagePreview.vue?vue&type=script&lang=js&"
import style0 from "./PagePreview.vue?vue&type=style&index=0&id=552b6e40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b6e40",
  null
  
)

export default component.exports